import {Account, AccountUser, User} from "models"
import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import AccountUsersTable from "components/account-users/table"
import AdminLayout from "components/admin/layout"
import AdminShowActions from "components/admin/show-actions"
import Button from "components/inputs/button"
import memo from "set-state-compare/build/memo"
import Nav from "./nav"
import Routes from "shared/routes"
import setLayout from "shared/set-layout"
import useCanCan from "@kaspernj/api-maker/build/use-can-can"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import useModel from "@kaspernj/api-maker/build/use-model"

export default memo(shapeComponent(class RoutesAdminAccountsAccountUsers extends ShapeComponent {
  setup() {
    setLayout("admin")

    const {t} = useI18n({namespace: "js.routes.admin.accounts.account_users"})
    const canCan = useCanCan(() => [[AccountUser, ["create"]]])
    const {account, accountId} = useModel(Account, {
      abilities: {
        Account: ["destroy", "edit"]
      },
      match: this.p.match
    })

    this.setInstance({
      account,
      accountId,
      accountUsersQuery: useMemo(() => AccountUser.ransack({account_id_eq: accountId}), [accountId]),
      canCan,
      t
    })
  }

  render() {
    const {account, accountUsersQuery} = this.tt

    return (
      <AdminLayout
        actions={this.actions()}
        active="users"
        className="routes--admin--accounts--account-users"
        headerTitle={User.humanAttributeName("AccountUsers")}
      >
        {account &&
          <Nav account={account} active="account-users" className="mb-4" />
        }
        <AccountUsersTable
          adminLayout
          collection={accountUsersQuery}
        />
      </AdminLayout>
    )
  }

  actions() {
    const {canCan, account, accountId} = this.tt

    return (
      <>
        {canCan.can("create", AccountUser) &&
          <Button
            className="new-account-user-button"
            icon="plus"
            label={this.t(".new_user_for_account")}
            to={Routes.newAdminAccountUserPath({account_user: {account_id: accountId}})}
          />
        }
        <AdminShowActions model={account} />
      </>
    )
  }
}))
